import moment from 'moment';
import {removeCart} from '../Cart.services';
import {CartDataProp} from '../interface/ICart';
import '../style/ShoppingCartItem.css';
import { getUserCurrency } from '../../../helpers/getUserCurrency';
import { useTranslation } from 'react-i18next';
import Modal from 'react-bootstrap/Modal';
import MainButton from '../../../UI/main-button/MainButton';
import CancelButton from '../../../UI/cancel-button/CancelButton';
import { useState } from 'react';
import trash from "./image.png"
import timer from "./timer.png";
import date from "./date.png";
import part from "./participants.png"
/* eslint-disable */

const ShoppingCartItem = ({data}: CartDataProp) => {
  const {t} = useTranslation();
  const userCountry = getUserCurrency()
  
  const getType = (type:any, startDate:any, date:any , tracking_type:any ) => {
    if( type == 'Tracking' ){
      if( startDate ){
        return 'Competition'
      }else{
        return 'Tracking'
      }
    }else if ( type === 'TrackingPackage' ){
      if( tracking_type ==='tracking' ){
        return 'Follow-up System Package'
      }else{
        return 'All Levels'
      }
    }if( type === 'Course' ){
      if( date ){
        return 'Live Course'
      }else{
        return type
      }
    }
    else{
      return type
    }
  };

  const [showConfirmDeleteUser, setShowConfirmDeleteUser] = useState(false);
  const [showConfirmDeleteItem, setShowConfirmDeleteIem] = useState(false);
  const [selectedMemberId, setSelectedMemberId] = useState<any>(null);

  return (
    <>
    <div className="course-item d-flex row bg-white w-100 ms-1 py-3">
      
      {/* <div className="course-image col-md-3">
        <img src={data.image} alt="course-img" />
      </div> */}
      <div className="course-details col-md-12">
        <div className="d-flex flex-column justify-content-between h-100">
          

          <div className="secondry-color  mb-2" style={{ fontSize : '20px' , fontWeight : '500' }}>
          {data.model_name == 'ConsultationSession' ? 
          moment(data.date).format('dddd DD-MM-YYYY hh:mm A')
           : '' }
          </div>

          
          <div className="d-flex justify-content-between align-items-center " style={{ width: "100%" }}>

  <div className="d-flex align-items-center  " style={{ gap: "15px", flex: 1 }}>
    <img src={data.image} className="rounded-3 mb-5  " alt={data.name} style={{ width: "80px", height: "80px", objectFit: "cover" }} />


    <div className="d-flex flex-column align-items-start justify-content-start pt-1 pt-3 ">
      <h6 className="fw-bold m-0 mb-1">{data.event_name }</h6>
      <p 
  className={`m-0 fw-semibold  ${data.is_available === 1 ? " text-success " : "text-danger"}`}
>
  {data.is_available === 1 ? "Available" : "Not available right now."}
</p>

      {data?.current_price && <span className="text-danger mb-1 fw-bold">${data.current_price} </span>}
      {data?.users_number && <span className="text-muted   mb-1"> <img src={part} alt=""  style={{width:"18px",height:"16px"}} className='me-1'/>{data.users_number} Participants Enrolled</span>}
      {data?.period && <span className="  mb-1"><img src={timer} alt=""  style={{width:"18px",height:"16px"}} className='me-1'/>{data.period} Days </span>}
      {data?.date_interval && <span className="text-muted mt-1 "><img src={date} alt=""  style={{width:"18px",height:"16px"}} className='me-2 '/>Camp Date : {data.date_interval}</span>}
    </div>
  </div>


  <div  className='mb-5 pb-5'
    onClick={() => {
      if ((data?.model_name === "Tracking" || data?.model_name === "TrackingPackage") && data?.tracking_type === "initiative") {
        setShowConfirmDeleteIem(true);
      } else {
        removeCart(data?.id, data?.is_soldout, data?.is_not_available, data?.model_id, data?.model_name);
      }
    }}
    role="button"
    style={{ cursor: "pointer", padding: "5px" }}
  >
    <img src={trash} alt="" style={{ width: "20px", height: "20px", color:"rgba(237, 88, 89, 1)" }} />
  </div>
</div>
       
      
{/* 
          { data.date != null ? 

          <div className='user-cart-data mt-2'>
            <img src={'/uiw_date.png'} alt="course-img"/>
            <span className='mx-2'>
            {data.tracking_type == 'initiative' ? 
            moment(data.date).format('DD-MM-YYYY')
            : '' }
            </span>
          </div>

          : ''  }
 */}

          <div className='d-flex align-items-center mt-2'>   
          { data.users_names && data.users_names.length > 0 ? <img src={'/user-gray.svg'} alt="course-img" /> : '' }    
          {data.users_names && data.users_names.map((item:any, i:any) => {

          return (

            <div className='user-cart-data mx-2 user-placeholder'
            onClick={() => {
              setSelectedMemberId(item.cart_id)
              setShowConfirmDeleteUser(true)
            }}
            >
              <img src={'/x.svg'} alt="course-img"/>
              <span className='mx-1'>{item.username}</span>
            </div>

          );
          })}

             
          </div>   
          

          
          {/* <div className='d-flex justify-content-between mt-2'>
              <div className='user-cart-data'>
                <img src={'/eva_pricetags-outline.svg'} alt="course-img"/>
                <span className='mx-1 font-weight-bold'>{data.price} {userCountry}</span>
              </div>

          
          </div> */}
          

        </div>
      </div>

      

      {data.is_soldout
      ?        
      <div
      style={{
        background: '#c7c7c7',
        textAlign: 'center',
        fontSize: '22px',
        padding: '1rem',
        borderRadius: '0px 0 10px 10px'

      }}  
      >
        <strong>{data.is_soldout ? 'Sold Out' : '' }</strong>
      </div>
      :
      ''
      }

      {/* {data.is_not_available
      ?        
      <div
      style={{
        background: '#c7c7c7',
        textAlign: 'center',
        fontSize: '22px',
        padding: '1rem',
        borderRadius: '0px 0 10px 10px'

      }}  
      >
        <strong>{data.is_not_available ? 'Un Covered Country' : '' }</strong>
      </div>
      :
      ''
      } */}
    </div>

    {/*Show delete assigned user*/}
    <Modal show={showConfirmDeleteUser} onHide={() => setShowConfirmDeleteUser(false)} centered size='sm'>
      <Modal.Header>
        <Modal.Title></Modal.Title>
      </Modal.Header>

      <Modal.Body>
      <h5 className="text-center">
          <img src={'/confirm.svg'} />
          <h2 className='popup-header'>
            {t('Delete a family member from the subscription list')}
          </h2>
          <p className='popup-desc'>
          {t('You are about to delete a family member from your subscriptions list. Are you sure about that?')}
          </p>
      </h5>
      </Modal.Body>

      <Modal.Footer>
        <div className="w-100" onClick={() => {
          removeCart(selectedMemberId,data.is_soldout,data.is_not_available,null,null);
        } }>
          <MainButton text={t('Confirm')} />
        </div>
        <div onClick={() => setShowConfirmDeleteUser(false)} className="w-100">
          <CancelButton text={t('Cancel')} />
        </div>
      </Modal.Footer>
    </Modal>

    {/*Show delete assigned user*/}
    <Modal show={showConfirmDeleteItem} onHide={() => setShowConfirmDeleteIem(false)} centered size='sm'>
      <Modal.Header>
        <Modal.Title></Modal.Title>
      </Modal.Header>

      <Modal.Body>
      <h5 className="text-center">
          <img src={'/big-delete.svg'} />
          <h2 className='popup-header'>
            {t('Delete subscription list competition')}
          </h2>
          <p className='popup-desc'>
          {t('You are about to delete a competition from your subscription list. Are you sure about that?')}
          </p>
      </h5>
      </Modal.Body>

      <Modal.Footer>
        <div className="w-100" onClick={() => {
          removeCart(data.id,data.is_soldout,data.is_not_available,data.model_id,data.model_name);
        } }>
          <MainButton text={t('Confirm')} />
        </div>
        
        <div onClick={() => setShowConfirmDeleteIem(false)} className="w-100">
          <CancelButton text={t('Cancel')} />
        </div>
      </Modal.Footer>
    </Modal>
    </>


  );
};

export default ShoppingCartItem;


